const state = {
// initial state
  userIsLogged: false,
  userInfo: {},
  userIsAdmin: false
};

// getters
const getters = {
  userIsLogged: state => state.userIsLogged,
  userInfo: state => state.userInfo,
  userIsAdmin: state => state.userIsAdmin,
};

const actions = {
  saveUserData (context, data) {
    context.commit('updateUserData', data)
  },
  deleteUserData (context, data) {
    context.commit('resetUserData')
  }
}

// mutations
const mutations = {
  updateUserData(state, data) {
    state.userIsLogged = true
    state.userInfo = data.advisor
    state.userIsAdmin = data.advisor.isAdmin
  },
  resetUserData() {
    state.userIsLogged = false
    state.userInfo = {}
    state.userIsAdmin = false
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/user-info.js